import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { FileUploadButton } from './FileUploadButton';
import { FileUploadList } from './FileUploadList';
export const FileUpload = props => {
    const [files, setFiles] = useState([]);
    const value = props.value;
    const state = props.state;
    const handleDelete = (index) => {
        var _a;
        const newFiles = files;
        newFiles[index].state = 'deleting';
        setFiles([...newFiles]);
        props.onDelete(index);
        (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props);
    };
    const handleUpload = (fileList) => {
        var _a;
        if (fileList.length > 0) {
            const newFiles = Array.from(fileList).map(file => {
                return { file: file, state: 'pending' };
            });
            setFiles(value => [...value, ...newFiles]);
            props.onChange(newFiles.map(file => file.file));
        }
        (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props);
    };
    useEffect(() => {
        switch (state) {
            case 'pending':
                setFiles(oldFiles => oldFiles.map(file => {
                    if (value.find(_file => _file === file.file)) {
                        file.state = undefined;
                    }
                    return file;
                }));
                break;
            case 'deleting':
                setFiles(oldFiles => oldFiles.filter(file => value.find(_file => _file === file.file)));
                break;
            default:
                if (value) {
                    setFiles(value.map(file => {
                        return {
                            file: file,
                        };
                    }));
                }
        }
    }, [value, setFiles]);
    useEffect(() => {
        // if error exists and new file is uploaded, delete first file
        if (props.error && files.length > 1) {
            handleDelete(0);
        }
    }, [props.error, files.length]);
    return (_jsxs(_Fragment, { children: [!props.error ? _jsx(FileUploadList, { disabled: props.disabled, files: files, onDelete: handleDelete }) : null, !value || (value && value.length < (props.numOfFiles || 1)) || (value && props.error) ? (_jsx(FileUploadButton, Object.assign({ disabled: props.disabled, onChange: handleUpload }, { children: props.children }))) : null] }));
};
